const JawsGraph = {
    1: { 2: 1, 3: 1, 5: 1, N: 1 },
    2: { 1: 1, 4: 1, 6: 1, E: 1 },
    3: { 1: 1, 4: 1, W: 1, 7: 1 },
    4: { 2: 1, 3: 1, S: 1, 8: 1 },
    5: { 1: 1, N: 1, W: 1},
    N: { 1: 1, 5: 1, 6: 1},
    6: { 2: 1, N: 1, E: 1},
    E: { 2: 1, 6: 1, 8: 1},
    W: { 3: 1, 5: 1, 7: 1},
    7: { 3: 1, W: 1, S: 1},
    S: { 4: 1, 7: 1, 8: 1},
    8: { 4: 1, E: 1, S: 1}
}

const JawsConnections = {
    1: [ 2, 3, 5, "N" ],
    2: [ 1, 4, 6, "E" ],
    3: [ 1, 4, "W", 7 ],
    4: [ 2, 3, "S", 8 ],
    5: [ 1, "N", "W"],
    N: [ 1, 5, 6],
    6: [ 2, "N", "E"],
    E: [ 2, 6, 8],
    W: [ 3, 5, 7],
    7: [ 3, "W", "S"],
    S: [ 4, 7, 8],
    8: [ 4, "E", "S"]
}

export { JawsGraph, JawsConnections }